var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000,600.000000) scale(0.100000,-0.100000)","stroke":"none"},React.createElement("path",{"d":"M1925 5971 c-72 -33 -145 -110 -172 -179 -17 -45 -18 -138 -21 -2287\nl-2 -2239 -543 540 c-610 609 -583 587 -729 587 -66 1 -85 -4 -142 -32 -107\n-52 -172 -146 -183 -265 -6 -70 15 -160 49 -211 28 -40 1870 -1885 1883 -1885\n6 0 431 422 946 938 756 757 941 947 960 987 33 71 33 209 0 276 -36 74 -86\n125 -157 160 -57 28 -76 33 -142 32 -146 0 -119 22 -729 -587 l-543 -540 -2\n2239 c-3 2149 -4 2242 -21 2287 -27 69 -100 146 -172 179 -50 24 -73 29 -140\n29 -67 0 -90 -5 -140 -29z"})));
}

ArrowDown.defaultProps = {"version":"1.0","width":"413.000000pt","height":"600.000000pt","viewBox":"0 0 413.000000 600.000000","preserveAspectRatio":"xMidYMid meet"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
